// extracted by mini-css-extract-plugin
module.exports = {"form":"EAFUseRecord_form__pxkn2","content":"EAFUseRecord_content__1xeWe","contentMain":"EAFUseRecord_contentMain__y_ChX","select":"EAFUseRecord_select__1xbai"};